import { z } from 'zod';
export const HardwareLabelFieldSchema = z.enum(['make', 'model', 'serial']);
export const HARDWARE_LABEL_FIELDS = HardwareLabelFieldSchema.options;
export const LabelReadingSchema = z
    .object({
    field: HardwareLabelFieldSchema,
    value: z.string().trim().min(1).max(160),
    printedText: z.string().trim().min(1).max(300),
})
    .strict();
export const LabelExtractionSchema = z
    .object({
    readings: z.array(LabelReadingSchema).max(3),
    needsClearerPhoto: z.boolean(),
})
    .strict();
export const HardwareSuggestionRequestSchema = z
    .object({
    inverterIndex: z.number().int().min(0).max(19),
    photoId: z.string().uuid(),
})
    .strict();
export const HardwareSuggestionReviewSchema = z
    .object({
    acceptFields: z.array(HardwareLabelFieldSchema).max(3),
})
    .strict();
export const HardwareSuggestionSchema = z.object({
    id: z.string().regex(/^[a-f0-9]{64}$/),
    jobId: z.string(),
    sourceRevision: z.string(),
    inverterIndex: z.number().int().nonnegative(),
    hardwareHash: z.string(),
    photoId: z.string(),
    photoHash: z.string(),
    photoUploadedAt: z.string(),
    requestedFields: z.array(HardwareLabelFieldSchema),
    extractorVersion: z.string(),
    requestedBy: z.string(),
    createdAt: z.string(),
    status: z.enum(['pending', 'ready', 'failed', 'reviewing', 'reviewed']),
    readings: z.array(LabelReadingSchema).max(3),
    needsClearerPhoto: z.boolean(),
    reviewedBy: z.string().optional(),
    reviewedAt: z.string().optional(),
    acceptedFields: z.array(HardwareLabelFieldSchema).optional(),
    appliedRevision: z.string().optional(),
});
export const HardwareLabelProvenanceSchema = z.object({
    suggestionId: z.string(),
    sourceRevision: z.string(),
    inverterIndex: z.number().int(),
    photoId: z.string(),
    photoHash: z.string(),
    extractorVersion: z.string(),
    readings: z.array(LabelReadingSchema),
    reviewedBy: z.string(),
    reviewedAt: z.string(),
});
//# sourceMappingURL=hardware-suggestions.js.map